import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '@src/lib/api'
import { City, CityResponseDTO } from '@src/types/cities'
import { ListResponseDTO, PaginatedResponseDto } from '@src/types/api'

export const citiesApi = createApi({
  reducerPath: 'citiesApi',
  baseQuery: baseQueryConfig('/cities'),
  endpoints: build => ({
    getCities: build.query<PaginatedResponseDto<City>, string>({
      query: (search: string) => ({
        url: '/' + (search ? `?s=${search}` : '')
      })
    }),
    searchCities: build.query<PaginatedResponseDto<City>, string>({
      query: (search: string) => ({
        url: '/search' + (search ? `?s=${search}` : '')
      })
    }),
    getActualCities: build.query<ListResponseDTO<CityResponseDTO>, void>({
      query: () => ({
        url: '/actual'
      })
    }),
  })
})

export const {
  useGetCitiesQuery,
  useGetActualCitiesQuery,
  useSearchCitiesQuery,
  useLazySearchCitiesQuery
} = citiesApi